import { createDateColumn } from './create-date';
import { expectedDeliveryDateColumn } from './expected-delivery-date';
import { orderDateColumn } from './order-date';
import { createPurchaseOrderNumberColumn } from './purchase-order-number';
import { purchaseOrderStatusColumn } from './purchase-order-status';
import { createReceiveInventoryColumn } from './receive-inventory';
import { referenceNumberColumn } from './reference-number';
import { supplierNameColumn } from './supplier-name';
import { warehouseColumn } from './warehouse';
import { purchaseOrderGridProperties } from '../../data/purchase-order-properties';

/**
 * Creates base column configuration for the purchase orders grid
 * @param {() => Promise<void>} refreshPurchaseOrders - Callback function to refresh purchase orders data
 * @returns {Record<string, unknown>} Column configuration object mapping property names to column definitions
 */
export function createBaseColumns(refreshPurchaseOrders) {
  return {
    [purchaseOrderGridProperties.purchaseOrderNumber]: createPurchaseOrderNumberColumn(refreshPurchaseOrders),
    [purchaseOrderGridProperties.referenceNumber]: referenceNumberColumn,
    [purchaseOrderGridProperties.supplierName]: supplierNameColumn,
    [purchaseOrderGridProperties.warehouseName]: warehouseColumn,
    [purchaseOrderGridProperties.purchaseOrderStatus]: purchaseOrderStatusColumn,
    [purchaseOrderGridProperties.createDate]: createDateColumn,
    [purchaseOrderGridProperties.orderDate]: orderDateColumn,
    [purchaseOrderGridProperties.expectedDeliveryDate]: expectedDeliveryDateColumn,
    [purchaseOrderGridProperties.receiveInventory]: createReceiveInventoryColumn(refreshPurchaseOrders),
  };
}
